import { h } from 'preact';

import { GlobalState } from '../states/global-state';

const Spinner = () => {
  const condition = GlobalState.showSpinner;
  if (condition.value == true) {
    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999,
          display: 'grid',
          justifyContent: 'center',
          alignContent: 'center',
          backgroundColor: 'rgba(0,0,0,0.2)',
        }}
      >
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }
};

export default Spinner;
